/*
 * The Chart Room — one tap from the landing page to checkout.
 *
 * The readings are a single-item purchase. Nobody buys two Life Charts, and
 * nobody adds a second reading to the basket first, so the cart page between
 * the button and the payment form is a step that exists only because Shopify's
 * default flow has one. This removes it: add the item over fetch, then go
 * straight to /checkout.
 *
 * SCOPE. The listener only fires for a form inside [data-cr-buy], which is
 * rendered by snippets/cr-buy-form.liquid and nothing else. Dawn's own product
 * form is untouched, and so is the existing-client gate on
 * templates/product.gated-addon.json — that template has no [data-cr-buy] on
 * it, and its gate is a capture-phase listener that would in any case run
 * before this one.
 *
 * IT LISTENS FOR submit, NOT click, on purpose. The mobile sticky bar calls
 * form.requestSubmit() on the same form (assets/cr-sticky-buy.js), which
 * dispatches a real submit event — so the bar gets the same one-tap route as
 * the button without either file knowing about the other.
 *
 * THE FALLBACK IS A REAL SUBMIT. If the fetch fails — offline, a 4xx from a
 * variant that sold out between page load and tap, an ad blocker eating the
 * request — the form is submitted for real. Its hidden return_to field sends
 * the browser to checkout anyway, so a failed enhancement costs a page load
 * and nothing else. form.submit() is used deliberately for that fallback: it
 * does not dispatch a submit event, so it cannot re-enter this handler.
 */
(function () {
  if (window.__crBuyNowBound) return;
  window.__crBuyNowBound = true;

  var CHECKOUT_URL = '/checkout';

  function cartAddUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root) return '/cart/add.js';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }

  function busy(button, on) {
    if (!button) return;
    if (on) {
      button.setAttribute('aria-busy', 'true');
      button.classList.add('cr-btn--busy');
    } else {
      button.removeAttribute('aria-busy');
      button.classList.remove('cr-btn--busy');
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.closest || !form.closest('[data-cr-buy]')) return;

      // No fetch, no enhancement: let the browser post the form itself.
      if (typeof window.fetch !== 'function' || typeof FormData !== 'function') return;

      event.preventDefault();

      var button = form.querySelector('[data-cr-buy-now]');
      if (form.dataset.crBuySubmitting === 'true') return;
      form.dataset.crBuySubmitting = 'true';
      busy(button, true);

      fetch(cartAddUrl(), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/add returned ' + response.status);
          return response.json();
        })
        .then(function () {
          window.location.href = CHECKOUT_URL;
        })
        .catch(function () {
          // Hand the job back to the browser rather than showing an error the
          // visitor can do nothing about.
          form.dataset.crBuySubmitting = 'false';
          form.submit();
        });
    },
    false
  );
})();
